import {Component} from '@angular/core';

@Component({
    selector: 'app-eligibility-criteria-section',
    templateUrl: './eligibility-criteria-section.component.html',
    styleUrls: ['../../../../assets/styles/new-styles.css']
})
export class EligibilityCriteriaSectionComponent {
}
